





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class Player extends Vue {
	// 当前播放状态
	private playing = false
	private draggingSpot = false
	private startX: any = null
	private startY: any = null
	private pastTime: any = 0
	private duration: any = 0
	private timer: any = null

	@Prop()
	private currentRecord!: any

	@Watch('audioUrl', { immediate: true })
	private onUrlChange() {
		if (!this.audioUrl) {
			return
		}
		this.$nextTick(() => {
			let audio: any = this.$refs.audio
			// mp3 mime type
			if (!audio.canPlayType('audio/mpeg')) {
				this.$message.error(
					'当前浏览器不支持播放，请下载直接播放或更换浏览器播放！'
				)
				return
			}
			// 播放过程中切换音源，需先将playing设为false 触发watcher
			this.playing = false
			audio.addEventListener('canplaythrough', this.initPlayer)
			audio.onended = () => {
				this.playing = false
				// 避免pastTime缺失最后一段小于interval的值
				this.pastTime = this.duration
			}
		})
	}

	@Watch('playing')
	private onPlayingChange() {
		let audio: any = this.$refs.audio
		if (!this.audioUrl) {
			return
		}
		if (!audio.canPlayType('audio/mp3')) {
			this.$message.error(
				'当前浏览器不支持播放，请下载直接播放或更换浏览器播放！'
			)
			return
		}
		if (this.playing) {
			audio.play()
			this.pastTime =
				audio.currentTime === audio.duration ? 0 : audio.currentTime
			this.duration = audio.duration
			this.setTimer()
		} else {
			audio.pause()
			this.timer && clearInterval(this.timer)
		}
	}

	@Watch('pastTime')
	private onTimePassing() {
		if (!this.duration || !isFinite(this.duration)) {
			// 防止被除数为0/无穷大
			return
		}
		let rate = this.pastTime / this.duration
		this.setCurrentBar(rate)
	}

	@Watch('duration')
	private onDurationChange() {
		this.$set(this.currentRecord, 'duration', this.secondsFormat(this.duration))
	}

	private get audioUrl() {
		return this.currentRecord.picUrl || ''
	}

	private initPlayer() {
		let audio: any = this.$refs.audio
		this.pastTime = 0
		this.duration = audio.duration
		this.playing = true
		audio.removeEventListener('canplaythrough', this.initPlayer)
	}

	private setTimer() {
		this.timer && clearInterval(this.timer)
		const interval = 50
		let audio: any = this.$refs.audio
		this.timer = setInterval(() => {
			this.pastTime = audio.currentTime
			this.duration = audio.duration
		}, interval)
	}

	private clearTimer() {
		this.timer && clearInterval(this.timer)
	}

	private secondsFormat(seconds: number | null) {
		if (!seconds || !isFinite(seconds)) {
			return '00:00'
		}
		let round = Math.round(seconds)
		let hour = Math.floor(round / (60 * 60))
		let last = round % (60 * 60)
		let minute = Math.floor(last / 60)
		let second = last - minute * 60
		let BASE = 10
		return `${hour ? (hour >= 10 ? hour : '0' + hour) + ':' : ''}${
			minute >= 10 ? minute : '0' + minute
		}:${second >= 10 ? second : '0' + second}`
	}

	private pause() {
		this.playing = false
	}

	private play() {
		if (this.audioUrl) {
			this.playing = true
		}
	}

	private onAudioSeek(evt: any) {
		// 在进度条上的一次拖拽行为完成也会触发click
		this.setPastTime(evt.clientX)
	}

	private setCurrentBar(rate: number) {
		// 避免获取到的时长偏短时出现异常
		if (rate >= 0 && rate <= 1) {
			let currentBar: any = this.$refs.currentBar
			currentBar.style.width = `${rate * 100}%`
		}
	}

	private setPastTime(clientX: number) {
		// 根据鼠标与进度条最左侧的距离设置当前时间
		let progressBar: any = this.$refs.progressBar
		if (!progressBar) {
			return
		}
		let rect: any = progressBar.getBoundingClientRect()
		let progressWidth: number = rect.width
		// getBoundingClientRect().x IE不能正確解析
		let progressClientX: number = rect.left
		let dist = clientX - progressClientX
		if (dist < 0) {
			this.pastTime = 0
		} else if (dist > progressWidth) {
			this.pastTime = this.duration
		} else {
			this.pastTime = (dist / progressWidth) * this.duration
		}
	}

	private dragBegin() {
		this.draggingSpot = true
		this.clearTimer()
	}

	private spotMoving(evt: any) {
		if (this.draggingSpot) {
			this.setPastTime(evt.clientX)
		}
	}

	private spotStop(evt: any) {
		if (this.draggingSpot) {
			// 一次拖拽动作完成
			this.draggingSpot = false
			// 拖动spot时，设置当前播放时间
			let audio: any = this.$refs.audio
			audio.currentTime = this.pastTime
			this.setTimer()
		}
	}

	private mounted() {
		document.addEventListener('mousemove', this.spotMoving)
		document.addEventListener('mouseup', this.spotStop)
	}

	private beforeDestroy() {
		this.timer && clearInterval(this.timer)
		document.removeEventListener('mousemove', this.spotMoving)
		document.removeEventListener('mouseup', this.spotStop)
	}
}
